import { format, parseISO } from 'date-fns';
import { DataListItem } from '@brighte/form-components';
import { Employee } from '@graphql/index';
import { TextOverflowStrategy } from '@spark-web/text';
import { FINANCE_PURCHASE } from '@utils';

function getVendorDetails(quote: {
  vendor: { tradingName: string; publicId: string };
  referenceNumber: string;
  expiryDate?: string;
  agent?: Employee;
}): { title: string; items: DataListItem[] } {
  // TEMPORARY: Hide agent's mobile for specific vendor public id
  const hideAgentMobileVendorsList = ['E235'];
  const { referenceNumber, expiryDate, agent, vendor } = quote;
  const { VENDOR_FIELDS } = FINANCE_PURCHASE;
  return {
    title: vendor?.tradingName,
    items: [
      ...(referenceNumber ? [{ label: VENDOR_FIELDS.referenceNumber, value: referenceNumber }] : []),
      // Omitted when absent, like the reference/mobile/email rows. Emitting it with an empty value left
      // a bare label on the page with nothing beside it.
      ...(expiryDate ? [{ label: VENDOR_FIELDS.expiryDate, value: format(parseISO(expiryDate), 'dd/MM/yyyy') }] : []),
      ...(agent?.mobile && !hideAgentMobileVendorsList.includes(vendor.publicId)
        ? [{ label: VENDOR_FIELDS.mobile, value: agent?.mobile }]
        : []),
      ...(agent?.email
        ? [
            {
              label: VENDOR_FIELDS.email,
              value: agent?.email,
              valueOverflowStrategy: 'breakword' as TextOverflowStrategy,
            },
          ]
        : []),
    ],
  };
}
export default getVendorDetails;
